import React, { useState } from "react";
import PropTypes from "prop-types";

const TextUpload = ({ uploading, onUpload }) => {
  const [textInput, setTextInput] = useState({ title: "", content: "" });

  const handleSubmit = () => {
    onUpload(textInput, () => setTextInput({ title: "", content: "" }));
  };

  return (
    <div className="km-text-section">
      <input
        type="text"
        className="km-input"
        placeholder="Snippet title"
        value={textInput.title}
        onChange={(e) => setTextInput({ ...textInput, title: e.target.value })}
        disabled={uploading}
      />
      <textarea
        className="km-textarea"
        placeholder="Enter text content..."
        rows={6}
        value={textInput.content}
        onChange={(e) =>
          setTextInput({ ...textInput, content: e.target.value })
        }
        disabled={uploading}
      />
      <button
        className="km-btn km-btn-primary"
        onClick={handleSubmit}
        disabled={
          uploading || !textInput.title.trim() || !textInput.content.trim()
        }
      >
        {uploading ? "Adding..." : "Add Text"}
      </button>
    </div>
  );
};

TextUpload.propTypes = {
  uploading: PropTypes.bool,
  onUpload: PropTypes.func.isRequired,
};

export default TextUpload;
